<div class="label">
  <div layout layout-align-items-center>
    <rt-icon name="add" size="small-x"></rt-icon>
    <span *ngIf="variant === 'wide'">{{ 'app.common.add_new' | translate }}</span>
  </div>
</div>
